export default __webpack_public_path__ + "static/iphone_app-c69629c1c73a8fc317aa1ca94fe537c2.jpg";